import { ChangeEvent } from 'react';
import { IoAddCircleOutline } from 'react-icons/io5';
import { Container } from './styles';

interface ThumbsProps {
  onSubmit: (e: ChangeEvent<HTMLInputElement>) => void;
  urlThumbnail?: string;
}

export const UploadThumbnail = ({ onSubmit, urlThumbnail }: ThumbsProps) => (
  <Container haveImage={!!urlThumbnail}>
    <label htmlFor="avatar">
      <IoAddCircleOutline />
      <input type="file" id="avatar" onChange={e => onSubmit(e)} />
      {urlThumbnail && <img src={urlThumbnail} alt="imagem" />}
    </label>
  </Container>
);
